import { Component, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { User, UserType } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection, AclService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { UserNewEditComponent } from '../user-new-edit/user-new-edit.component';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, AfterViewInit, OnDestroy {


	@Input()
	companyid: number;

	loading: boolean = false;
	rows: User[] = [];

	advancedSearch: Search = new Search('user', `concat(fname,'',lname)`, 'user');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;
	loggedUser: User;
	subcription: Subscription;
	isAdmin: boolean;



	constructor(private crudService: CrudService<User>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private sharedDataService: SharedDataService,
		private modalService: NgbModal,
		private aclService: AclService) {
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.loggedUser = data as unknown as User;
				this.isAdmin = (this.loggedUser.utype === UserType.admin);
			}
		});

	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
				this.companyid = this.loggedUser.companyid;
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}

	}




	loadItems() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		const datarequest = this.crudService.searchEntities(User, 'user', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.crudService.countEntities(User, 'user', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {

		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.loadItems();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.loadItems();
	}

	onActivate(event: any) {

		if (event.type === 'dblclick') {
			if (!this.companyid) {// la scheda si fa vedere solo se non siamo dentro all'azienda, per semplificare il percorso
				this.router.navigate([`/user/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			} else {
				this.edit(event.row.id);
			}
		}

	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;

			if (this.companyid) {
				this.advancedSearch.addSimpleFilter('companyid', this.companyid);
				this.advancedSearch.addSimpleFilter('utype', 'company');
			}
		}
		this.loadItems();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: User, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-user-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.crudService.deleteEntity(User, 'user', row).subscribe(() => {
					this.translateService.get(['labels.user-deleted', 'labels.users']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.user-deleted'], messages['labels.users']);
						this.loadItems();
					});
				});
			}
		});
	}

	lock(row: User) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-user-lock'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				row.status = 'locked';
				this.crudService.saveEntity(User, 'user', row).subscribe(() => {
					this.messageService.sendSuccess(
						this.translateService.instant('labels.user-locked'), this.translateService.instant('labels.users')
					);
					this.loadItems();
				});
			}
		});
	}

	unlock(row: User) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-user-unlock'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				row.status = 'active';
				this.crudService.saveEntity(User, 'user', row).subscribe(() => {
					this.messageService.sendSuccess(
						this.translateService.instant('labels.user-unlocked'), this.translateService.instant('labels.users')
					);
					this.loadItems();
				});
			}
		});
	}

	edit(uid: number): void {
		const modal = this.modalService.open(UserNewEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.companyid = this.companyid;
		let rolespermission = false;

		this.aclService.hasPermission('roles').subscribe((r: boolean) => {
			rolespermission = r;

			if (!this.companyid || !rolespermission) {
				modal.componentInstance.showroles = false;
			}
			if (uid) {
				modal.componentInstance.load(uid);
			}
			modal.result.then((newItem: User) => {
				this.loadItems();
			}).catch(() => { });


		})


	}

}
